import React from 'react';
import SassyProps from './SASSYProps.json';
// import Plot from 'react-plotly.js';
import Plotly from './PlotlyCustom';
import createPlotlyComponent from 'react-plotly.js/factory';
const Plot = createPlotlyComponent(Plotly);
let { colors, segments } = SassyProps;
class SASSYSegmentPieChart extends React.Component {
  constructor(props) {
    super(props);
    let { data } = this.props;
    let series = [], total = 0, textInfo;

    if (data) {
      series = data.map(segment => segment.value)
      total = series.reduce((sum, value) => sum += value, total);
      textInfo = series.map(seg => `${Math.fround((seg / total) * 100).toFixed(1)}%`)
    }

    this.state = {
      data: [{
        values: series,
        labels: segments,
        type: 'pie',
        marker: {
          colors,
          line: {
            color: "#EFEFEF",
            width: 1
          }
        },
        textinfo: 'label+text',
        text: textInfo,
        hoverinfo: 'none',
        showlegend: false,
        insidetextfont: {
          color: "#EFEFEF",
          size: 14
        },
        outsidetextfont: {
          size: 12
        }

      }],
      layout: {
        autosize: true,
        height: 370,
        margin: {
          b: 30,
          t: 30,
          pad: 40
        },
        paper_bgcolor: "transparent"
      },
      frames: [],
      config: {
        responsive: true,
        displayModeBar: false
      }
    };

    /* // sort in order of segments
    Object.assign(this.state.data[0], {
      sort: false,
      direction: "clockwise"
    }) */
  }

  render() {
    return (
      <Plot
        data={this.state.data}
        layout={this.state.layout}
        frames={this.state.frames}
        config={this.state.config}
        onInitialized={(figure) => this.setState(figure)}
        onUpdate={(figure) => this.setState(figure)}
        useResizeHandler={true}
      />
    );
  }
}

export default SASSYSegmentPieChart;